import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { setTabCategory, addCategory, toggleMenuOpen } from "common/actions";
import { getTabColor } from "common/store";
import { Categories } from "common/models/categories";
import { tabColor, tabTextColor, borderColor } from "common/constants/Colors";

type Props = {
  categories: Categories;
  addCategory: ({ categoryName }) => void;
  setTabCategory: (id: string) => void;
  toggleMenuOpen: () => void;
};

class Tabs extends React.Component<Props> {
  _addCat = () => {
    const inputCatName: string = prompt(
      "追加するカテゴリ名を入力してください（15文字以内)"
    );
    if (inputCatName) {
      this.props.addCategory({ categoryName: inputCatName });
    }
  };

  _toggleMenu = () => {
    this.props.toggleMenuOpen();
  };

  render() {
    const { categories } = this.props;
    const borderColor: string = getTabColor(categories.nowTabCategory);

    return (
      <Wrapper bordercolor={borderColor}>
        <button className="btn" onClick={() => this._toggleMenu()}>
          <i className="fas fa-bars" />
        </button>
        {categories.order.map((catId: string, index: number) => {
          const catName: string = categories.list[catId].name;
          const isActive: boolean = Boolean(
            catId === categories.nowTabCategory
          );
          return (
            <button
              key={index}
              data-active={isActive}
              className="tab catTab"
              onClick={() => this.props.setTabCategory(categories.order[index])}
            >
              <span className="tabCurve tabCurveLeft" />
              {catName}
              <span className="tabCurve tabCurveRight" />
            </button>
          );
        })}
        <button className="btn" onClick={this._addCat}>
          <i className="fas fa-plus" />
        </button>
        <button
          className="tab trashTab"
          data-active={!categories.nowTabCategory}
          onClick={() => this.props.setTabCategory(null)}
        >
          ゴミ箱
          <i className="fas fa-trash-alt" />
        </button>
      </Wrapper>
    );
  }
}

export default connect(({ categories }) => ({ categories }), {
  addCategory,
  setTabCategory,
  toggleMenuOpen
})(Tabs);

interface WrapperProps {
  bordercolor: string;
}

const Wrapper = styled.div`
  width: 100%;
  height: 45px;
  overflow: scroll;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  transition: border-color 0.2s;
  border-bottom: solid 3px ${(props: WrapperProps) => props.bordercolor};

  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }

  .tab {
    transition: width 0.2s;
    display: block;
    line-height: 1.5em;
    white-space: nowrap;
    text-align: left;
    padding: 0.5em 1em;
    margin: 0;
    border-radius: 7px 7px 0 0;
  }
  .catTab {
    color: #fff;
    background-color: #ddd;
    &:nth-child(5n + 2) {
      background-color: ${tabColor[0]};
      color: ${tabTextColor[0]};
      .tabCurve::before {
        border-color: ${tabColor[0]};
      }
    }
    &:nth-child(5n + 3) {
      background-color: ${tabColor[1]};
      color: ${tabTextColor[1]};
      .tabCurve::before {
        border-color: ${tabColor[1]};
      }
    }
    &:nth-child(5n + 4) {
      background-color: ${tabColor[2]};
      color: ${tabTextColor[2]};
      .tabCurve::before {
        border-color: ${tabColor[2]};
      }
    }
    &:nth-child(5n + 5) {
      background-color: ${tabColor[3]};
      color: ${tabTextColor[3]};
      .tabCurve::before {
        border-color: ${tabColor[3]};
      }
    }
    &:nth-child(5n + 6) {
      background-color: ${tabColor[4]};
      color: ${tabTextColor[4]};
      .tabCurve::before {
        border-color: ${tabColor[4]};
      }
    }
    .tabCurve {
      display: none;
    }
    &[data-active="true"] {
      position: relative;
      .tabCurveLeft {
        left: -7px;
        &:before {
          bottom: -11px;
          left: -23px;
        }
      }
      .tabCurveRight {
        right: -7px;
        &:before {
          bottom: -11px;
          right: -23px;
        }
      }
      .tabCurve {
        position: absolute;
        display: block;
        bottom: 0;
        width: 7px;
        height: 7px;
        background-color: transparent;
        overflow: hidden;
        &:before {
          content: "";
          position: absolute;
          width: 20px;
          height: 20px;
          border-width: 10px;
          border-style: solid;
          border-radius: 50%;
        }
      }
    }
  }

  .trashTab {
    background-color: #fff;
    transition: width 0.2s, background-color 0.2s;
    margin: 0 32px 0 0;
    border-color: ${borderColor};
    border-width: 1px 1px 0 1px;
    border-style: solid;
    &:hover {
      opacity: 1;
      background-color: #ccc;
    }
    i {
      margin-left: 8px;
    }
    &[data-active="true"] {
      color: #fff;
      background-color: #999;
      i {
        color: #fff;
      }
    }
  }
  .btn {
    padding: 8px 16px;
    box-sizing: border-box;
  }

  [data-active="true"] {
    padding: 0.7em 1em 0.5em;
    font-weight: bold;
  }
`;
